import { Modal } from '@mui/material';
import CandidateTrainingsForm from './CandidateTrainingsForm';

const CandidateTrainingsModal = ({
  isOpen,
  onClose,
  onSubmit,
  register,
  errors,
  handleSubmit,
  watch,
  setValue,
  isSubmitting,
  isEditMode,
  defaultValues,
  classes,
  classesLoading,
}) => {
  return (
    <Modal open={isOpen} onClose={onClose}>
      <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-30 z-50">
        <div className="bg-white rounded-2xl shadow-2xl p-8 md:p-12 w-full md:w-[900px] max-w-4xl max-h-[90vh] overflow-y-auto border border-gray-200 relative">
          {/* Submitting overlay */}
          {isSubmitting && (
            <div className="absolute inset-0 bg-white bg-opacity-75 flex items-center justify-center z-10 rounded-lg">
              <div className="flex flex-col items-center">
                <div className="w-8 h-8 border-4 border-secondary-200 border-t-secondary-700 rounded-full animate-spin mb-2"></div>
                <span className="text-secondary-700 font-medium">Saving...</span>
              </div>
            </div>
          )}

          {/* Modal Header with Close Button */}
          <div className="flex items-center justify-between mb-6">
            <h2 className="text-2xl font-bold text-secondary-800">
              {isEditMode ? 'Edit Training' : 'Add Training'}
            </h2>
            <button
              type="button"
              onClick={onClose}
              className="text-gray-500 hover:text-secondary-800 text-2xl font-bold px-2"
              aria-label="Close"
            >
              &times;
            </button>
          </div>

          <CandidateTrainingsForm
            register={register}
            errors={errors}
            handleSubmit={handleSubmit}
            onSubmit={onSubmit}
            closeModal={onClose}
            watch={watch}
            setValue={setValue}
            isSubmitting={isSubmitting}
            isEditMode={isEditMode}
            defaultValues={defaultValues}
            classes={classes}
            classesLoading={classesLoading}
          />
        </div>
      </div>
    </Modal>
  );
};

export default CandidateTrainingsModal;
